<template>
  <div v-if="color" class="w-2.5 h-2.5 rounded-full absolute" :class="componentClass"></div>
</template>

<script>
import { computed, ref } from 'vue'
import { useTypeStyles } from '@/composables/useTypeStyles'

export default {
  name: 'UpdateMark',
  props: {
    color: String,
    tr: String
  },
  setup (props) {
    const { getColorClasses } = useTypeStyles()
    const hasPing = ref(true)

    setTimeout(() => {
      hasPing.value = false
    }, 1000)

    const componentClass = computed(() => {
      const base = [
        props.tr ?? 'top-0 right-0',
        ...getColorClasses(props.color, 'bg'),
        ...getColorClasses(props.color, 'border')
      ]

      if (hasPing.value) {
        base.push('animate-ping')
      }

      return base
    })

    return {
      componentClass
    }
  }
}
</script>
